const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

import router from '@/router';
import eventBus from '@/services/eventBus';
import keycloakService from '@/services/keycloakService';
import store from '@/store';
import { createBootstrap } from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { createApp } from 'vue';
import VueToggles from 'vue-toggles';
import App from './App.vue';
import './assets/css/style.css';
import registerBootstrapCompat from './bootstrapCompat.js';
import './registerServiceWorker';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const initApp = async () => {
  try {
    const storedState = await store.dispatch('restoreState');
    if (storedState) {
      store.replaceState({ ...store.state, ...storedState });
    }
    await keycloakService.init();
    const app = createApp(App);
    app.use(createBootstrap());
    app.provide('eventBus', eventBus);
    app.provide('keycloak', keycloakService);
    registerBootstrapCompat(app);
    app.component('VueToggles', VueToggles);
    app.use(store);
    app.use(router);
    await router.isReady();
    app.mount('#app');
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.error('App initialization failed:', err);
    }
  }
};

initApp();
